import { useState } from "react";
import "./CBS3.css";

interface CBS3Props {
  onComplete: (tier: string) => void;
  onDecline: () => void;
}

type TierKey = "500" | "1000" | "undecided";

const TIERS: { key: TierKey; amount: string; label: string }[] = [
  {
    key: "500",
    amount: "£500",
    label: "I'd consider committing £500 when the round goes live",
  },
  {
    key: "1000",
    amount: "£1,000",
    label: "I'd consider committing £1,000 when the round goes live",
  },
  {
    key: "undecided",
    amount: "?",
    label: "I'm interested but haven't decided on an amount yet",
  },
];

export default function CBS3({ onComplete, onDecline }: CBS3Props) {
  const [selectedTier, setSelectedTier] = useState<TierKey | null>(null);
  const [submitted, setSubmitted] = useState(false);
  const [fading, setFading] = useState(false);

  const handleSubmit = () => {
    if (!selectedTier) return;
    setFading(true);
    setTimeout(() => {
      setSubmitted(true);
    }, 600);
    setTimeout(() => {
      onComplete(selectedTier);
    }, 3200);
  };

  if (submitted) {
    return (
      <div className="cbs3-overlay">
        <div className="cbs3-overlay-content">
          <div className="overlay-emoji">🎉</div>
          <h2>You're one of us now.</h2>
          <div className="overlay-body">
            <p>
              A huge thank you for coming this far with us. Alex and the team
              will be in touch soon to share more details about the round.
            </p>
            <p className="overlay-highlight">
              You've become one of our founding members.
            </p>
            <p>
              You'll find everything - your booking, updates, and investment
              details - in your member dashboard. Sign in anytime via the
              website.
            </p>
            <p className="overlay-closer">
              We're building spaces that help us grow better. See you on the
              inside.
            </p>
          </div>
          <div className="overlay-signoff">Taking you to your dashboard...</div>
          <div className="overlay-logo">LOA</div>
        </div>
      </div>
    );
  }

  return (
    <div className="cbs3-container">
      <div className={`cbs3-form-area ${fading ? "fading" : ""}`}>
        <div className="cbs3-header">
          <div className="cbs3-label">
            FOUNDING INVESTOR EXPRESSION OF INTEREST
          </div>
          <h2>How much are you thinking?</h2>
          <p className="cbs3-sub">
            This is not a binding commitment and no money changes hands today.
            We're simply recording intent so we can keep you informed when the
            round goes live.
          </p>
        </div>

        <div className="tier-cards">
          {TIERS.map(({ key, amount, label }) => (
            <button
              key={key}
              className={`tier-card ${selectedTier === key ? "selected" : ""}`}
              onClick={() => setSelectedTier(key)}
              disabled={fading}
            >
              <div className="tier-amount">{amount}</div>
              <div className="tier-label">{label}</div>
              {selectedTier === key && <div className="tier-check">✓</div>}
            </button>
          ))}
        </div>

        <div className="cbs3-disclaimers">
          <p>
            This is an expression of interest only, not a binding commitment. ·
            Investments in early-stage businesses carry risk, including loss of
            capital. · This is not financial advice. · We'll be in touch with
            full details before any money is involved.
          </p>
        </div>

        <button
          className={`cbs3-submit ${selectedTier ? "active" : ""}`}
          onClick={handleSubmit}
          disabled={!selectedTier || fading}
        >
          Register My Interest
        </button>

        <button className="cbs3-decline" onClick={onDecline} disabled={fading}>
          Thanks, just the session for now
        </button>
      </div>
    </div>
  );
}
